export default __webpack_public_path__ + "static/media/cart1hover.499ab3d6.jpg";